import { render, staticRenderFns } from "./my-order.vue?vue&type=template&id=5ba84bf7&scoped=true"
import script from "./my-order.vue?vue&type=script&lang=js"
export * from "./my-order.vue?vue&type=script&lang=js"
import style0 from "./my-order.vue?vue&type=style&index=0&id=5ba84bf7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba84bf7",
  null
  
)

export default component.exports